function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// mega_menu_slider
var mega_menu_slider = new Swiper(".mega_menu_slider", {
  slidesPerView: 4,
  spaceBetween: 16,
  breakpoints: {
    0: {
        slidesPerView: 2.32,
        spaceBetween: 12
    },
    992: {
        slidesPerView: 3,
        spaceBetween: 12
    },
    1141: {
        slidesPerView: 4
    }
  } 
});

document.addEventListener("DOMContentLoaded", (event) => {
  // infinity_slider
  var infinity_slider = new Swiper(".infinity_slider", {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 0,
    allowTouchMove: false,
    speed: 2000,
    autoplay: { 
      delay: 1,
      enabled: true,
    }
  });


  // people_slider
  var people_slider = new Swiper(".people_slider", {
    slidesPerView: 4,
    spaceBetween: 16,
    loop: true,
      navigation: {
      nextEl: ".swiper-button-next.people_arrow",
      prevEl: ".swiper-button-prev.people_arrow",
    },
    breakpoints: {
      0: {
          slidesPerView: 1.53,
          centeredSlides: true
      },
      476: {
          slidesPerView: 2,
          centeredSlides: true
      },
      768: {
          slidesPerView: 3
      },
      992: {
          slidesPerView: 4
      }
    } 
  });

  // bestseller_slider
  var bestseller_slider = new Swiper(".bestseller_slider", {
    slidesPerView: 4,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
      navigation: {
      nextEl: ".swiper-button-next.product_arrow",
      prevEl: ".swiper-button-prev.product_arrow",
    },
    breakpoints: {
      0: {
          slidesPerView: 1.49
      },
      476: {
          slidesPerView: 2
      },
      768: {
          slidesPerView: 3
      },
      992: {
          slidesPerView: 4
      }
    } 
  });

  // needed_slider
  var needed_slider = new Swiper(".needed_slider", {
    slidesPerView: 3,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      0: {
          slidesPerView: 1.39
      },
      476: {
          slidesPerView: 2
      },
      768: {
          slidesPerView: 3
      }
    } 
  });

  var rated_slider = new Swiper(".rated_slider", {
    slidesPerView: 3,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next.rated_arrow",
      prevEl: ".swiper-button-prev.rated_arrow",
    },
    pagination: {
      el: ".swiper-pagination.rated_pagination",
    },
    breakpoints: {
      0: {
          slidesPerView: 1.42
      },
      476: {
          slidesPerView: 2.3
      },
      768: {
          slidesPerView: 3
      }
    } 
  });
});

// header fixed js
function headerspace() {
    var header = document.querySelector('.header');
    var mobileMenu = document.querySelector('.on_mobile_menu');
    var wrapper = document.querySelector('.wrapper');

    if (header && wrapper) {
        var headerHeight = header.offsetHeight;
        // wrapper.style.paddingTop = headerHeight + 'px';
        // mobileMenu.style.top = headerHeight + 'px';
        document.body.style.setProperty('--header-height', headerHeight + 'px');
    }
}

// Run on page load
headerspace();

// Run on window resize and orientation change
window.addEventListener('resize', headerspace);
window.addEventListener('orientationchange', headerspace);


// Slide up returns a promise
function slideUp(element, duration = 300) {
  return new Promise(resolve => {
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = `hidden`;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    requestAnimationFrame(() => {
      element.style.height = '0';
    });
    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('transition');
      element.style.removeProperty('overflow');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      resolve();
    }, duration);
  });
}

// Slide down returns a promise
function slideDown(element, duration = 300) {
  return new Promise(resolve => {
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.height = '0';
    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = `hidden`;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    requestAnimationFrame(() => {
      element.style.height = height + 'px';
    });
    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('transition');
      element.style.removeProperty('overflow');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      resolve();
    }, duration);
  });
}

function slideToggle(element, duration = 300) {
  if (window.getComputedStyle(element).display === 'none') {
    slideDown(element, duration);
  } else {
    slideUp(element, duration);
  }
}

function isVisible(element) {
  return window.getComputedStyle(element).display !== 'none';
}

// tab section js
document.querySelectorAll('ul.tabs li').forEach(tab => {
  tab.addEventListener('click', function () {
    const tabId = this.getAttribute('data-tab');
    const parent = this.closest('.has_parent');
    
    parent.querySelectorAll('.tab_content_img').forEach(li => li.classList.remove('current'));
    parent.querySelectorAll('ul.tabs li').forEach(li => li.classList.remove('current'));
    parent.querySelectorAll('.tab_content').forEach(tc => tc.classList.remove('current'));

    this.classList.add('current');
    const target = document.getElementById(tabId);
    const mob_img = parent.querySelector(`.tab_content_img[data-image-id="${tabId}"]`);
    if (target) target.classList.add('current');
    if (mob_img) mob_img.classList.add('current');

    if (parent.querySelectorAll("[data-accordion]").length > 0) {
      parent.querySelectorAll("[data-accordion]").forEach((group, groupIndex) => {
        const accordions = parent.querySelectorAll("[data-accordion-title]");
        accordions.forEach((accordion, index) => {
          const panel = accordion.nextElementSibling;

          if (accordion.classList.contains("active")) {
              panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    }
  });
});
 
// Accordian Common Js
document.addEventListener("DOMContentLoaded", (event) => {
  const accordionGroups = document.querySelectorAll("[data-accordion]");
  if (accordionGroups.length > 0) {
    accordionGroups.forEach((group, groupIndex) => {
        const accordions = group.querySelectorAll("[data-accordion-title]");
        const parent = group.parentNode;
        const accordionsAll = parent.querySelectorAll("[data-accordion-title]");
  
        accordions.forEach((accordion, index) => {
            const panel = accordion.nextElementSibling;
  
            if (accordion.classList.contains("active")) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }

            const images = panel.querySelectorAll("img");
            images.forEach((img) => {
              img.addEventListener("load", () => {
                if (accordion.classList.contains("active")) {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
              });
            });
  
            accordion.addEventListener("click", () => {
                const isActive = accordion.classList.contains("active");
  
                accordionsAll.forEach((acc) => {
                    acc.classList.remove("active");
                    const accPanel = acc.nextElementSibling;
                    accPanel.style.maxHeight = null; 
                });
  
                if (!isActive) {
                    accordion.classList.add("active");
                   panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });

        });
    });
  }

  window.addEventListener("resize", () => {
    document.querySelectorAll('[data-accordion-title].active').forEach((accordion) => {
      const content = accordion.nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

});


// header_menu open and close
document.addEventListener('click', function (e) {
  if (e.target.closest('.toggle_menu')) {
    const mobileIcon = e.target.closest('.mobile_icon');
    const headerLeft = e.target.closest('.header_left');
    document.body.querySelector('.menu_overlay')?.classList.add('is-open');
    mobileIcon?.classList.add('is-open');
    headerLeft?.querySelector('.on_mobile_menu')?.classList.add('is-open');
  }

  if (e.target.closest('.drawer_close') || e.target.closest('.menu_overlay')) {
    document.querySelectorAll('.mobile_icon, .on_mobile_menu, .menu_overlay').forEach(el => el.classList.remove('is-open'));
  }
});

// Vidos play pause on click
document.querySelectorAll('.people_video').forEach(wrapper => {
  const video = wrapper.querySelector('video');
  const playBtn = wrapper.querySelector('.play_icon');

  const togglePlayback = () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
    updateUI();
  };

  const updateUI = () => {
    if (video.paused) {
      video.classList.remove('is-playing');
      video.classList.add('is-paused');
    } else {
      video.classList.add('is-playing');
      video.classList.remove('is-paused');
    }
  };
  
  playBtn.addEventListener('click', togglePlayback);
  video.addEventListener('click', togglePlayback);
  video.addEventListener('pause', updateUI);
  video.addEventListener('play', updateUI);
});

// product thum slider 
var pdp_thumbslider = new Swiper(".pdp_thumbslider", {
    spaceBetween: 5,
    slidesPerView: 5,
    watchSlidesProgress: true,
});
var pdp_main_slider = new Swiper(".pdp_main_slider", {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination.pdp_slider_pagination',
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next.pdp_arrow",
        prevEl: ".swiper-button-prev.pdp_arrow",
    },
    thumbs: {
      swiper: pdp_thumbslider,
    },
});

// variant js
function getVariantPrice(variantId) {  
  const variant = window.variantData.find(v => v.id == variantId);
  return variant ? variant.price : null;
}

function addBtnText(disable, text, btnElement,varaint) {
  if (!btnElement) return;

  btnElement.disabled = disable;
  const span = btnElement.querySelector('span');
  if (!span) return;

  if (disable) {
    if (text) {
      span.textContent = text;
    }

    const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');

    // Only hide main button IF Klaviyo element exists
    if (klaviyoTrigger) {
      if (btnElement) {
        btnElement.style.display = 'none';
      }

      klaviyoTrigger.style.display = 'block';
    }

  } else {
    let price = getVariantPrice(varaint.id);
    if (price) {
      span.textContent = `add to cart | ${price}`;
    }

    // Restore button if needed
    if (btnElement) {
      btnElement.style.display = '';
    }

    const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');
    if (klaviyoTrigger) {
      klaviyoTrigger.style.display = 'none';
    }
  }

}

function varaintSelect(form, _this) {
  const selector = _this.closest('.varaint-selector');
  const selectorIndex = selector?.dataset.index;
  const selectorQty = selector?.dataset.qty;
  const section = selector?.dataset.section;
  const productId = form?.dataset.productId;
  const url = selector?.dataset.url;

  const jsonData = selector.querySelector('[type="application/json"]');
  const getVariantData = JSON.parse(jsonData?.textContent || '[]');

  const fieldsets = Array.from(selector.querySelectorAll('.product-form__input'));
  const addButton = form.querySelector('[name="add"]');
  const options = [];

  
  fieldsets.forEach(fs => {
    const checked = fs.querySelector("input[type='radio']:checked");
    if (checked) {
      options.push(checked.value);
    }
  });

  let currentVariant = null;

  getVariantData.forEach(variant => {
    let match = true;
    variant.options.forEach((opt, idx) => {
      if (options[idx] !== opt) {
        match = false;
      }
    });
    if (match) {
      currentVariant = variant;
    }
  });

  console.log(currentVariant);
  addBtnText(false, '', addButton,currentVariant);

  if (!currentVariant || !currentVariant.available) {
    addBtnText(true, 'Sold out', addButton,currentVariant);
    if (addButton) {
      const span = addButton.querySelector('.button-text');
      if (span) span.textContent = "Sold out";      
    }
    return;
  }

  /* slider scroll to trigger on variant image changes :Start */  
  waitForProductSwiper(currentVariant);
  /* slider scroll to trigger on variant image changes :End */

  form.querySelectorAll(`#product-form-${productId}`).forEach((productForm) => {
    var input = productForm.querySelector('input[name="id"]');    
    if (input) {
      input.value = currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  

  // Update the URL in the browser
  if (history.replaceState && currentVariant.id) {
    const newUrl = `${url}?variant=${currentVariant.id}`;
    window.history.replaceState({}, '', newUrl);
  }

  // Fetch the new section for availability check
  fetch(`${url}?variant=${currentVariant.id}&section_id=${section}`)
    .then(response => response.text())
    .then(data => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const updateSourceFromDestination = (id, index, count, shouldHide = (source) => false) => {
        if (index || count) {
          var source = html.getElementById(`${id}-${section}-${count}-${index}`) || html.getElementById(`${id}-${section}-${index}`);
          var destination = form.querySelector(`#${id}-${section}-${count}-${index}`) || form.querySelector(`#${id}-${section}-${index}`);
        } else {
          var source = html.getElementById(`${id}-${section}`);
          var destination = form.querySelector(`#${id}-${section}`);
        }
        
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.toggle('hidden', shouldHide(source));
        }
      };
      updateSourceFromDestination('selectedValue', selectorIndex);
      // for (let i = 0; i < document.querySelectorAll('.varaint-selector').length; i++) {
      //   var j = i + 1;
        updateSourceFromDestination('currentImage', selectorIndex, selectorQty);
      // }
      updateSourceFromDestination('varaintSelector');
      updateSourceFromDestination('price');
      updateSourceFromDestination('pdp_bundle');
      //addBtnText(!currentVariant.available, window.variantStrings.soldOut, addButton);
      stickyButton();
    })
    .catch(err => {
      console.error('Variant section fetch error:', err);
    });
}

/* Slider image changes on variant changes and match : Start */
  function resolveMainSwiper() {
    if (window.productMainSwiper && typeof window.productMainSwiper.slideTo === 'function') {
      return window.productMainSwiper;
    }

    const mainEl = document.querySelector('.product_hero_main');
    if (mainEl && mainEl.swiper && typeof mainEl.swiper.slideTo === 'function') {
      return mainEl.swiper;
    }
    return null;
  }

  function resolveThumbSwiper() {
    if (window.productThumbSwiper && typeof window.productThumbSwiper.slideTo === 'function') {
      return window.productThumbSwiper;
    }

    const thumbEl = document.querySelector('.product_hero_thumbh');
    if (thumbEl && thumbEl.swiper && typeof thumbEl.swiper.slideTo === 'function') {
      return thumbEl.swiper;
    }
    return null;
  }

  function waitForProductSwiper(variant, retries = 20) {
    const mainSwiper = resolveMainSwiper();
    const thumbSwiper = resolveThumbSwiper();

    if (mainSwiper && variant?.featured_media) {
      const index = variant.featured_media.position - 1;
      if (typeof mainSwiper.slideToLoop === 'function') {
        mainSwiper.slideToLoop(index);
      } else {
        mainSwiper.slideTo(index);
      }
      if (thumbSwiper) {
        thumbSwiper.slideTo(index);
        thumbSwiper.update();
      }
      return;
    }
    // if (retries > 0) {
    //   setTimeout(() => waitForProductSwiper(variant, retries - 1), 300);
    // }
  }


  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('variant');
    return id ? parseInt(id, 10) : null;
  }

  document.addEventListener('DOMContentLoaded', () => {
    let variantId = getVariantIdFromUrl();
    if (!variantId) {
      variantId = window.Shopify?.analytics?.meta?.selectedVariantId;
    }

    if (!variantId) return;

    const selector = document.querySelector('.varaint-selector');
    const jsonData = selector.querySelector('[type="application/json"]');
    const getVariantData = JSON.parse(jsonData?.textContent || '[]');

    const currentVariant = getVariantData.find(v => v.id === variantId);
    if (!currentVariant) return;

    waitForProductSwiper(currentVariant);
    
  });

  /* Slider image changes on variant changes and match : End */

// Event listener for variant selection change
document.addEventListener('change', function (e) {
  const input = e.target;
  if (input.matches('#variant_picker input[type="radio"]')) {    
    const form = input.closest('[data-product]');    
    if (form) {
      varaintSelect(form, input);
    }
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.btnMinus = null;
    this.btnPlus = null;
    this._initialized = false; 
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector('input[type="number"]');
    this.btnMinus = this.querySelector('.qty_btn.minus');
    this.btnPlus = this.querySelector('.qty_btn.plus');

    // Set default min value
    if (this.input) {
      this.input.setAttribute('min', '1');
    }

    // Event listeners
    if (this.btnMinus) {
      this.btnMinus.addEventListener('click', this.decrease.bind(this));
    }

    if (this.btnPlus) {
      this.btnPlus.addEventListener('click', this.increase.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', this.validateMin.bind(this));
    }
  }

  decrease(e) {
    e.preventDefault();
    const current = parseInt(this.input.value) || 1;
    if (current > 1) {
      this.input.value = current - 1;
      this.triggerChange();
    }
  }

  increase(e) {
    e.preventDefault();    
    const current = parseInt(this.input.value) || 1;
    this.input.value = current + 1;
    this.triggerChange();
  }

  validateMin() {
    if (parseInt(this.input.value) < 1 || isNaN(this.input.value)) {
      this.input.value = 1;
      this.triggerChange();
    }
  }

  triggerChange() {
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// Register the custom element
customElements.define('quantity-input', QuantityInput);

// Sticky submit button
var stickyButton = (() => {
    var mainPdp = document.querySelector('.pdp_hero');
    if (mainPdp) {
        let submitBtn = mainPdp.querySelector('.product-form__submit'),
            pdpShiping = mainPdp.querySelector('.pdp_shiping');

        if (submitBtn && pdpShiping) {
            var oldWrap = document.querySelector('.sticky-submit-wrap');
            if (oldWrap) oldWrap.remove();

            document.body.insertAdjacentHTML('beforeend', `<div class="sticky-submit-wrap pdp_btn_wpr">${submitBtn.outerHTML}${pdpShiping.outerHTML}</div>`);

            let stickyWrap = document.querySelector('.sticky-submit-wrap'),
                clonedBtn = stickyWrap.querySelector('.product-form__submit');

            clonedBtn.addEventListener('click', e => {
                e.preventDefault();
                submitBtn.click();
            });
            
            
            window.addEventListener('scroll', () => {
                let submitRect = submitBtn.getBoundingClientRect(),
                    headerHeight = document.querySelector('header').offsetHeight;

                if (submitRect.top + submitRect.height >= headerHeight) {
                    stickyWrap.classList.remove('active');
                } else {
                    stickyWrap.classList.add('active');
                }
            });
        }
    }
})
document.addEventListener("DOMContentLoaded", (event) => {
  stickyButton()
});

/*---- Upsell Slider ReInit Listener ---*/
let upsellInitLock = false;
function initUpsellSlider() {
  const container = document.querySelector('.upsell_slider');
  const wrapper = document.querySelector('.upsell_slider .swiper-wrapper');

  if (!container || !wrapper || !wrapper.querySelector('.swiper-slide')) return;

  if (container.classList.contains('swiper-initialized')) return;

  // Destroy swiper
  if (container.swiper) {
    container.swiper.destroy(true, true);
  }

  container.classList.add('swiper-initialized');
  // Init AFTER layout is ready
  requestAnimationFrame(() => {
    new Swiper('.upsell_slider', {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next.upsell_arrow',
        prevEl: '.swiper-button-prev.upsell_arrow'
      },
      observer: true,
      observeParents: true
    });
  });
}


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    upsellInitLock = false;
    initUpsellSlider();
  }, 150);
});

// ---- MutationObserver ----
const cartDrawer = document.querySelector('#CartDrawer');
if (cartDrawer) {
  const observer = new MutationObserver(() => {    
    upsellInitLock = false;
    // Run init
    setTimeout(() => {
      if (!upsellInitLock) {
        upsellInitLock = true; 
        initUpsellSlider();
      }
    }, 120);

  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}



